import * as Types from './types';

export const requestExternal = () => ({
  type: Types.REQUEST_EXTERNAL
});

export const validationFailed = () => ({
  type: Types.RESPONSE_VALIDATION_FAILED
});
